"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InventoryActionsConfigurationEntity_1 = __importDefault(require("./Entity/InventoryActionsConfigurationEntity"));
var InventoryActionsConfiguration = /** @class */ (function () {
    function InventoryActionsConfiguration(session) {
        this.InventoryActionsConfigurationEntity = new InventoryActionsConfigurationEntity_1.default(session);
    }
    InventoryActionsConfiguration.prototype.getAll = function () {
        return this.InventoryActionsConfigurationEntity.service.getAll();
    };
    InventoryActionsConfiguration.prototype.create = function (inventoryActionConfiguration) {
        return this.InventoryActionsConfigurationEntity.service.create(inventoryActionConfiguration);
    };
    InventoryActionsConfiguration.prototype.update = function (id, inventoryActionConfiguration) {
        return this.InventoryActionsConfigurationEntity.service.update(id, inventoryActionConfiguration);
    };
    InventoryActionsConfiguration.prototype.delete = function (id) {
        return this.InventoryActionsConfigurationEntity.service.delete(id);
    };
    return InventoryActionsConfiguration;
}());
exports.default = InventoryActionsConfiguration;
//# sourceMappingURL=InventoryActionsConfiguration.js.map